import React from "react";
import clsx from "clsx";
import BookingButtonBuilderSidebar from "./BookingButtonBuilderSidebar";
import BookingButtonBuilderWorkspace from "./BookingButtonBuilderWorkspace";
import Errors from "../../Errors/Errors";

class BookingButtonBuilderGeneral extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'general',
			'tab-pane': true,
		})

		return (
			<div className={tabClasses} id="general">
				<Errors errors={this.props.errors} /> 
				<div className="booking-button-builder">
					<div className="row">
						<div className="col-md-4">
							<h5>{I18n.t('preferences')}</h5>
							<BookingButtonBuilderSidebar {...this.props}  />
						</div>
						<div className="col-md-8">
							<h5>{I18n.t('preview')}</h5>
							<BookingButtonBuilderWorkspace {...this.props} />
						</div>
					</div>
					<br />
					<br />
				</div>
			</div>
		);
	}
}

export default BookingButtonBuilderGeneral
